module.exports = __webpack_public_path__ + "img/1.20b7bc68.png";